import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type TestimonialsProps = {
  testimonials: Testimonial[];
  kicker?: string;
  title: string;
  background?: 'cream' | 'white';
};
export function Testimonials({
  testimonials,
  kicker,
  title,
  background = 'white'
}: TestimonialsProps) {
  if (testimonials.length === 0) return null;
  const surface = background === 'cream' ? 'bg-cream' : 'bg-white';
  const card = background === 'cream' ? 'bg-white border-cream-dark' : 'bg-cream border-cream-dark';
  return <section aria-labelledby={`testimonials-${title.replace(/\s+/g, '-').toLowerCase()}`} className={`w-full ${surface}`} data-id="element-234" data-mp="2x0jngkbrvvde">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-235" data-mp="2s309llizlklz">
        {kicker && <p className="text-xs sm:text-sm font-semibold uppercase tracking-[0.14em] text-ink-muted text-center" data-id="element-236" data-mp="v8dmbo8h2gdg">
            {kicker}
          </p>}
        <h2 id={`testimonials-${title.replace(/\s+/g, '-').toLowerCase()}`} className="mt-3 font-serif font-bold text-ink text-2xl sm:text-4xl text-center" data-id="element-237" data-mp="h5y7wcgvp92k">
          {title}
        </h2>

        <ul className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-238" data-mp="78aaferw1ngp">
          {testimonials.map(testimonial => <li key={testimonial.quote} className={`flex flex-col rounded-2xl border shadow-card p-6 sm:p-7 ${card}`} data-id="element-239" data-mp="c7wmvlzw6zog">
              <QuoteIcon className="w-5 h-5 text-sage/50 shrink-0" aria-hidden="true" data-id="element-240" data-mp="14vj0zo6qxmpk" />
              <blockquote className="mt-4 font-serif text-[17px] leading-relaxed text-ink" data-id="element-241" data-mp="q5lav2p9amxq">
                {testimonial.quote}
              </blockquote>

              <div className="mt-auto pt-6 flex items-center gap-3" data-id="element-242" data-mp="v3d4c15juh41">
                {testimonial.photo ? <img src={testimonial.photo} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border border-cream-dark shrink-0" width={96} height={96} loading="lazy" data-id="element-243" data-mp="1nlqq32dm2cmr" /> : <span className="w-12 h-12 rounded-full bg-sage-tint border border-sage-soft flex items-center justify-center font-serif font-bold text-sage text-sm shrink-0" aria-hidden="true" data-id="element-244" data-mp="1ofrf4r1lyeof">
                    {testimonial.author.charAt(0)}
                  </span>}
                <div data-id="element-245" data-mp="14t22249zidp4">
                  <p className="text-sm font-semibold text-ink" data-id="element-246" data-mp="14ud7s9mzpviv">
                    {testimonial.author}
                  </p>
                  <p className="text-xs text-ink-muted" data-id="element-247" data-mp="10tb3hee7uta1">
                    {testimonial.context}
                  </p>
                </div>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}